import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function PantryStaples({ brand, isActive, width }) {
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';
    const bagColor = brand === MISFITS_THEME_DOMAIN ? '#B0BDCD' : '#63ACDE';
    const bottleColor = brand === MISFITS_THEME_DOMAIN ? '#A9C580' : '#BCD975';
    const bottleCapColor = brand === MISFITS_THEME_DOMAIN ? '#348C53' : '#547420';
    const olivePitColor = brand === MISFITS_THEME_DOMAIN ? '#AB363A' : '#CE3935';
    const logoBgColor = brand === MISFITS_THEME_DOMAIN ? '#F2EBD1' : '#ECE7E4';
    const flourColor = brand === MISFITS_THEME_DOMAIN ? '#E3C367' : '#F7D46D';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                fill={activeColor}
            />
            <path
                d="M17.2804 5.69923C17.2804 5.69923 15.9659 12.2473 10.2818 19.7043C10.2818 19.7043 9.46509 18.7833 9.44657 17.5214C9.44657 17.5214 12.5576 10.0183 17.2777 5.70378L17.2804 5.69923Z"
                fill="white"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.8843 10.0594L26.733 9.07341C26.9153 8.86282 26.8476 8.53825 26.6055 8.4106L18.3147 4.17059C18.0999 4.05871 17.8319 4.16517 17.7474 4.39577L17.2803 5.69924L25.8843 10.0594Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.8845 10.0594L17.2804 5.6992C17.2804 5.6992 15.966 12.2472 10.2819 19.7042C10.2819 19.7042 14.8887 23.4026 19.2878 23.9259C19.2878 23.9259 24.5058 17.8337 25.8819 10.0639L25.8845 10.0594Z"
                fill="white"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.1149 11.3767C21.146 11.7226 21.1483 12.0763 21.0177 12.4078C20.8297 12.8702 20.4153 13.1776 19.9636 13.3602C19.9363 13.3444 19.9243 13.1128 19.9245 13.0704C19.8996 12.3454 20.1942 11.8352 20.8371 11.4896C20.8979 11.4579 21.015 11.3919 21.0725 11.3765C21.0941 11.3707 21.0993 11.3616 21.1168 11.3839L21.1149 11.3767Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.6106 13.7582C21.3895 14.0254 21.1411 14.2768 20.8123 14.415C20.3528 14.6113 19.839 14.5333 19.3955 14.3441C19.3859 14.3081 19.5419 14.1431 19.5747 14.1074C20.0683 13.5785 20.6432 13.4245 21.3352 13.6357C21.3977 13.6536 21.5274 13.692 21.582 13.7235C21.6003 13.7341 21.6074 13.7321 21.6106 13.7582Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.0474 14.7446C20.8263 15.0117 20.5779 15.2631 20.2491 15.4013C19.7896 15.5976 19.2758 15.5196 18.8323 15.3304C18.8227 15.2945 18.9787 15.1294 19.0115 15.0937C19.5051 14.5648 20.08 14.4108 20.7719 14.622C20.8345 14.6399 20.9641 14.6783 21.0188 14.7099C21.037 14.7204 21.0442 14.7185 21.0474 14.7446Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.7819 12.125C18.661 12.45 18.5675 12.7909 18.6122 13.1447C18.672 13.6408 18.9964 14.0468 19.3821 14.3362C19.418 14.3266 19.4829 14.109 19.4975 14.0627C19.7087 13.3708 19.5546 12.7959 19.0257 12.3023C18.979 12.257 18.8809 12.1639 18.8262 12.1324C18.808 12.1219 18.806 12.1147 18.7819 12.125Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.2091 13.1065C18.0883 13.4315 17.9947 13.7723 18.0395 14.1261C18.0993 14.6223 18.4237 15.0282 18.8093 15.3177C18.8452 15.3081 18.9101 15.0904 18.9247 15.0442C19.1359 14.3522 18.9819 13.7774 18.453 13.2837C18.4062 13.2385 18.3081 13.1454 18.2534 13.1138C18.2352 13.1033 18.2333 13.0961 18.2091 13.1065Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.9639 13.3604L17.5705 17.5058"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.2818 19.7046C10.2818 19.7046 14.8886 23.403 19.2877 23.9263C19.2877 23.9263 19.9868 23.1152 20.9339 21.7062C16.5374 21.1783 11.8712 17.4882 11.8712 17.4882L10.2863 19.7073L10.2818 19.7046Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8646 17.4782C11.841 17.5192 11.8127 17.5576 11.7845 17.5959C11.326 18.2849 10.8218 18.9899 10.2797 19.6973C10.2797 19.6973 9.46304 18.7763 9.44908 17.517C9.44908 17.517 9.92067 16.3741 10.7808 14.7266C10.4382 16.3509 11.7769 17.4093 11.8646 17.4782Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6606 11.6798C11.9051 12.4094 12.0937 13.1539 12.2938 13.9008L15.1175 24.4387C15.2904 25.084 14.7829 25.7918 13.9903 26.0042L10.642 26.9013C9.84935 27.1137 9.0574 26.7596 8.88313 26.1092L6.03909 15.4951C5.70146 14.235 5.34014 13.0085 5.25928 11.6905C5.20022 10.7588 5.34151 9.90409 5.69855 8.98066C5.96879 8.28199 5.91584 7.63725 5.73477 6.96148C5.71298 6.88018 5.44206 5.86908 5.4407 5.86399L7.96593 5.18736C7.96593 5.18736 8.23821 6.20355 8.26 6.28485C8.44107 6.96061 8.71758 7.54546 9.30095 8.0154C10.0719 8.63659 10.6216 9.30615 11.0363 10.1426C11.2846 10.6424 11.4885 11.1596 11.6606 11.6798Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.39803 3.06848L4.8728 3.74512L5.43916 5.85879L7.96439 5.18216L7.39803 3.06848Z"
                fill={bottleCapColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.0806 4.19272L4.84912 5.05859L5.08873 5.95284L8.32022 5.08697L8.0806 4.19272Z"
                fill={bottleCapColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7769 15.1834L11.6611 14.7516C11.3181 13.4712 10.0038 12.7124 8.72341 13.0555C7.44301 13.3985 6.68423 14.7128 7.02731 15.9932L8.3057 20.7642C8.3057 20.7642 8.32167 20.8035 8.32712 20.8238L8.73419 22.343C8.8431 22.7495 9.26186 22.9913 9.66833 22.8823L12.8287 22.0355C13.2352 21.9266 13.4769 21.5079 13.368 21.1014L11.7996 15.2481C11.7996 15.2481 11.7887 15.2075 11.7782 15.1885L11.7769 15.1834Z"
                fill={logoBgColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1698 17.4498C11.6012 16.7026 11.2779 15.7082 10.4477 15.2289C9.61741 14.7495 8.59463 14.9667 8.16322 15.7139C7.73181 16.4611 8.05513 17.4555 8.88538 17.9348C9.71563 18.4142 10.7384 18.197 11.1698 17.4498Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.011 16.399C9.12745 16.0459 8.99819 15.6858 8.72229 15.5948C8.44639 15.5039 8.12833 15.7164 8.01188 16.0695C7.89543 16.4227 8.02469 16.7827 8.30058 16.8737C8.57648 16.9647 8.89455 16.7522 9.011 16.399Z"
                fill={olivePitColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6469 19.7055C12.1262 18.8752 11.9091 17.8524 11.1618 17.421C10.4146 16.9896 9.42027 17.3129 8.94093 18.1432C8.46158 18.9734 8.67874 19.9962 9.42597 20.4276C10.1732 20.859 11.1675 20.5357 11.6469 19.7055Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.2798 17.9842C11.3708 17.7083 11.1582 17.3902 10.8051 17.2737C10.4519 17.1573 10.0919 17.2866 10.0009 17.5625C9.90993 17.8384 10.1225 18.1564 10.4756 18.2729C10.8288 18.3893 11.1888 18.2601 11.2798 17.9842Z"
                fill={olivePitColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.2183 11.0005C13.2183 11.0005 15.3539 17.3285 14.1598 26.6285C14.1598 26.6285 12.9921 26.2392 12.3451 25.1556C12.3451 25.1556 11.2878 17.1023 13.2183 11.0057V11.0005Z"
                fill="white"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.8496 10.4748L23.0916 9.1966C23.1442 8.92307 22.9233 8.67584 22.6497 8.68636L13.3497 9.15978C13.1078 9.1703 12.9289 9.39648 12.971 9.63845L13.2182 11.0008L22.8496 10.4748Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.8494 10.4746L13.218 11.0006C13.218 11.0006 15.3537 17.3286 14.1596 26.6286C14.1596 26.6286 19.9984 27.5281 24.0698 25.7818C24.0698 25.7818 25.5426 17.8967 22.8494 10.4799V10.4746Z"
                fill="white"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.3779 14C19.5778 14.284 19.7566 14.5891 19.8092 14.9416C19.8776 15.436 19.6724 15.9094 19.3726 16.2934C19.341 16.2934 19.2148 16.0988 19.1938 16.062C18.8098 15.4466 18.8098 14.8574 19.1938 14.2367C19.2306 14.1788 19.299 14.0631 19.341 14.021C19.3568 14.0053 19.3568 13.9947 19.3831 14.0053L19.3779 14Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.9979 15.8147C20.9401 16.1566 20.8506 16.4985 20.635 16.7826C20.3351 17.1824 19.8512 17.3717 19.3725 17.4296C19.3462 17.4033 19.3988 17.1824 19.4093 17.135C19.5724 16.4301 19.9932 16.0093 20.6981 15.8463C20.7612 15.8305 20.8927 15.7989 20.9558 15.7989C20.9769 15.7989 20.9821 15.7937 20.9979 15.8147Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.0033 16.9509C20.9454 17.2928 20.856 17.6348 20.6403 17.9188C20.3405 18.3186 19.8566 18.508 19.3779 18.5658C19.3516 18.5395 19.4042 18.3186 19.4147 18.2712C19.5778 17.5664 19.9986 17.1456 20.7035 16.9825C20.7666 16.9667 20.8981 16.9352 20.9612 16.9352C20.9822 16.9352 20.9875 16.9299 21.0033 16.9509Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7314 15.8147C17.7893 16.1566 17.8787 16.4985 18.0944 16.7826C18.3942 17.1824 18.8782 17.3717 19.3568 17.4296C19.3831 17.4033 19.3305 17.1824 19.32 17.135C19.157 16.4301 18.7361 16.0093 18.0313 15.8463C17.9682 15.8305 17.8366 15.7989 17.7735 15.7989C17.7525 15.7989 17.7472 15.7937 17.7314 15.8147Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7261 16.9509C17.7839 17.2928 17.8734 17.6348 18.089 17.9188C18.3889 18.3186 18.8728 18.508 19.3515 18.5658C19.3778 18.5395 19.3252 18.3186 19.3146 18.2712C19.1516 17.5664 18.7308 17.1456 18.0259 16.9825C17.9628 16.9667 17.8313 16.9352 17.7682 16.9352C17.7471 16.9352 17.7419 16.9299 17.7261 16.9509Z"
                fill={flourColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.3726 16.2935V21.0802"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1597 26.6288C14.1597 26.6288 19.9985 27.5283 24.0699 25.782C24.0699 25.782 24.2697 24.7299 24.3855 23.0361C20.3141 24.7773 14.4279 23.9146 14.4279 23.9146L14.1649 26.6288H14.1597Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.4175 23.9094C14.4175 23.9568 14.4122 24.0041 14.407 24.0514C14.3544 24.8773 14.2702 25.74 14.1545 26.6237C14.1545 26.6237 12.9867 26.2344 12.345 25.1508C12.345 25.1508 12.1819 23.9252 12.103 22.0684C12.6185 23.6464 14.307 23.8936 14.4175 23.9094Z"
                fill={bagColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.4186 12.4213C12.466 13.1893 12.4554 13.9573 12.4554 14.7306V25.6402C12.4554 26.3082 11.7821 26.8606 10.9615 26.8606H7.49507C6.67449 26.8606 6.00118 26.3135 6.00118 25.6402V14.6517C6.00118 13.3471 5.96962 12.0689 6.23263 10.7749C6.41674 9.85963 6.77443 9.0706 7.35831 8.27106C7.80017 7.66613 7.91589 7.02965 7.91589 6.33005C7.91589 6.24588 7.91589 5.19911 7.91589 5.19385H10.5302C10.5302 5.19385 10.5302 6.24588 10.5302 6.33005C10.5302 7.02965 10.6459 7.66613 11.0878 8.27106C11.6717 9.0706 12.0294 9.85963 12.2135 10.7749C12.3239 11.322 12.387 11.8743 12.4186 12.4213Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5303 3H7.91602V5.18824H10.5303V3Z"
                fill={bottleCapColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.8985 4.26221H7.55298V5.188H10.8985V4.26221Z"
                fill={bottleCapColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6242 15.835V15.3879C11.6242 14.0623 10.5511 12.9893 9.22555 12.9893C7.89998 12.9893 6.8269 14.0623 6.8269 15.3879V20.3272C6.8269 20.3272 6.83216 20.3693 6.83216 20.3903V21.9631C6.83216 22.3839 7.17408 22.7259 7.59489 22.7259H10.8667C11.2875 22.7259 11.6295 22.3839 11.6295 21.9631V15.9034C11.6295 15.9034 11.6295 15.8613 11.6242 15.8403V15.835Z"
                fill={logoBgColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.4514 17.8673C11.0615 17.2572 11.0066 16.213 10.3287 15.5351C9.65078 14.8572 8.60665 14.8023 7.99654 15.4124C7.38643 16.0225 7.44139 17.0666 8.11929 17.7445C8.79718 18.4224 9.84131 18.4774 10.4514 17.8673Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.63838 16.2935C8.84226 15.9826 8.81059 15.6013 8.56764 15.442C8.32469 15.2828 7.96246 15.4057 7.75857 15.7167C7.55469 16.0277 7.58636 16.4089 7.82931 16.5682C8.07226 16.7275 8.43449 16.6045 8.63838 16.2935Z"
                fill={olivePitColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.3287 20.1695C11.0066 19.4916 11.0615 18.4474 10.4514 17.8373C9.84131 17.2272 8.79718 17.2822 8.11928 17.9601C7.44139 18.638 7.38644 19.6821 7.99654 20.2922C8.60665 20.9023 9.65078 20.8473 10.3287 20.1695Z"
                fill={bottleColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.4194 18.4122C10.5787 18.1693 10.4558 17.807 10.1448 17.6031C9.8338 17.3992 9.45258 17.4309 9.2933 17.6739C9.13401 17.9168 9.25698 18.2791 9.56796 18.4829C9.87894 18.6868 10.2602 18.6552 10.4194 18.4122Z"
                fill={olivePitColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

PantryStaples.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PantryStaples.defaultProps = {
    isActive: false,
    width: 30,
};
